<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card
      light
      tile
      :class="{
        accent: newThis.type === 'lay',
        secondary: newThis.type === 'back'
      }"
    >
      <v-card-title style="white-space: nowrap; font-size: 14px !important">
        Are you sure you want to place the bet?
      </v-card-title>

      <v-card-text class="pb-0">
        <v-row>
          <v-col cols="6" class="pb-0">
            <v-text-field
              v-show="newThis.bettingType === 'fancy'"
              :value="newThis.runs"
              label="Runs"
              outlined
              readonly
            ></v-text-field>
            <v-text-field
              v-show="newThis.bettingType !== 'fancy'"
              :value="
                newThis.bettingType === 'lineLadder'
                  ? ceilMethod(newThis.odds)
                  : newThis.odds
              "
              :label="newThis.bettingType === 'lineLadder' ? 'Runs' : 'Odds'"
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="pb-0">
            <v-text-field
              :value="newThis.stake"
              label="Stake"
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="pb-0">
            <v-text-field
              :value="newThis.winning"
              :label="newThis.type === 'lay' ? 'Liability' : 'Profit'"
              outlined
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="black" outlined depressed tile @click="dialog = false">
          No
        </v-btn>

        <v-btn
          dark
          color="green"
          depressed
          tile
          @click="
            dialog = false
            $listeners.confirm('betConfirmed')
          "
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ConfirmBetdialogue',
  props: { newThis: { type: [Array, Object], default: () => {} } },
  computed: {
    dialog: {
      get() {
        return this.$store.getters['confirmBet/model']
      },
      set(v) {
        return this.$store.commit('confirmBet/set', v)
      }
    }
  }
}
</script>
